import { useLang } from 'hooks/lang';

import { invoiceControlConfigByCode, isOwner } from 'entities';

import { Row, Button } from 'components/Blocks';
import { PropertyWithIcon } from 'components/PropertyWithIcon';

import { RefreshIcon, TagIcon } from 'components/Icons';

import { TicketModal } from './TicketModal';

import { useToggleV2, useUser } from 'hooks';
import { useProjectProfile } from 'pages/Projects/ProjectProfile/context';

export function FreshDeskTickets() {
  const { t } = useLang();

  const user = useUser();

  const { project } = useProjectProfile();

  const [isOn, onHandlers] = useToggleV2();

  const {
    invoice: { freshDeskTickets },
  } = project;

  const ticketText = freshDeskTickets?.join(', ') || 'N/A';

  return (
    <PropertyWithIcon
      icon={<TagIcon />}
      name={t('freshdesk-tickets')}
      alignItems="center"
      value={
        <Row gap="2">
          <span>{ticketText}</span>

          {isOwner(project.invoice, user) &&
            invoiceControlConfigByCode[project.invoice.status].canMutateFreshdeskTickets && (
              <>
                <TicketModal on={isOn} close={onHandlers.turnOff} />

                <Button variant="ghost" onClick={onHandlers.turnOn}>
                  <RefreshIcon />

                  {t('change')}
                </Button>
              </>
            )}
        </Row>
      }
    />
  );
}
